import { toast } from "sonner";
import { useApp } from "@/context/AppContext";
import { PREVIEW_BLOCKED } from "@/lib/api";

export const usePreviewGuard = () => {
  const { preview } = useApp();
  const guard = (fn) => (e) => {
    if (preview) {
      e?.preventDefault?.();
      toast.error(PREVIEW_BLOCKED, { id: "preview-blocked" });
      return;
    }
    fn?.(e);
  };
  return { preview, guard };
};
